import React from 'react';
import PropTypes from 'prop-types';
import './css/Text.css'; // 스타일 시트 추가 (필요시)
 

const Text = ({ variant, children, className, ...props }) => {
    const variants = {
        h1: 'text-h1',
        h2: 'text-h2',
        h3: 'text-h3',
        body: 'text-body',
        caption: 'text-caption',
        titlename: 'text-title', // title variant 추가
        titlename_B: 'text-title_B', // title variant 추가
        link: 'text-link', //link variant 추가
        px48: 'text-48px',
        px32: 'text-32px',
        px28: 'text-28px',
        px28_ESG: 'text-28px_ESG',
        px24: 'text-24px',
        px24News: 'text-24px_news',
        px24w600: 'text-24px600w',
        px24w600_B: 'text-24px600w_B', //사업분야
        px24w600_Blue : 'text-24px600w_Blue', //찾아 오시는길 지도보기
        px20: 'text-20px',
        px20w400: 'text-20px400w',
        px20w600: 'text-20px600w',
        px18: 'text-18px',
        px18w400: 'text-18px400w',
        px18w400_B: 'text-18px400w_B',//사업분야
        px16w300 : 'text-16px300w',
        px16w400: 'text-16px400w',
        px16w400_map: 'text-16px400w_map', //지도보기
        px16w400c66: 'text-16px400w66clr',
        px16: 'text-16px',
        px16w600: 'text-16px600w',
        px14: 'text-14px',
        px12: 'text-12px',
        px32w700B: 'text-32px700WBlue',// 회사생활 블루 색상 제목 추가
        px20wB: 'text-20pxBlue',// URL
        px20wB_det: 'text-20pxBlue_det',// URL
        px16wB: 'text-16pxBlue',// URL
        px20w400G :'text-20px400wGray',
        px16w400G :'text-16px400wGray',
        px16w400B :'text-16px400wBlack',
        px20w500O :'text-20px500wOrange',
        px20w500 :'text-20px500wBlack',
        px32w500W :'text-32px500wWhite',
        px32B :'text-32pxBlue',
        px28w400:'text-28px400w',
        px60w600:'text-60px600w',
        px60w200:'text-60px200w',
        px30w700:'text-30px700w',
        px36w700:'text-36px700w',
        px34w700:'text-34px700w',
        px48w600:'text-48px600w',
        px40w100:'text-40px100w',
        px14R: 'text-14pxRed',
        px18R: 'text-18pxRed',
        px30w500:'text-30px500w',
        px20w400B: 'text-20px400wBlue',  //파일다운로드 및 링크, 채용공고 - 페이지이동
        px20w400B_det:'text-20px400wBlue_det',
        px28w600: 'text-28px600w', //경영이념 큰글자
        px18w400LR: '18px400wLB',  //경영비전 (*쟁반~)
        px50w800B: 'text-50px800wB', //회사연혁 연도
        px50w600: 'text-22px600w',  //회사연혁 연도아래 문구
        px20w600_rec : 'text-20px600w_Rec',  //채용공고 상세 - 굵은글자
        px20w400_rec : 'text-20px400w_Rec',  //채용공고 상세 - 공고본문
        px24w600_rec : 'text-24px600w_Rec'  // 채용공고 카드 - 공고제목

    };

    const Tag = variant in variants ? variant : 'span';

    return (
        <Tag className={`${variants[variant]} ${className}`} {...props}>
            {children}
        </Tag>
    );
};

Text.propTypes = {
    variant: PropTypes.oneOf(['h1', 'h2', 'h3', 'body', 'caption', 'titlename', 'titlename_B','link', 'text-16px400w_map', 'text-24px600w_Blue', 'text-20pxBlue_det'
                                ,'px48','px32','px28','px24', 'text-title_tab', 'text-title_mob', 'text-24px600w', 'text-24px_news'
                                ,'px20','px18','px16','px14','px12', 'text-18px400w', 'text-28px700WBlue', 'text-18px700WBlue', '.text-20px400wBlue_det'
                                ,'px16w600','px16w400','px20w600', 'px16w400c66','text-16px300w', 'px24w600B', 'text-24px600w_B'
                                ,'px20wB','px20w400G','px16wB','px16w400G','px16w400B', 'px20w500O','px32w500W','px32B', 'text-18px400w_B'
                                ,'px28w400','px60w600','px60w200','px30w700','px36w700','px34w700','px48w600','px40w100' , 'px20w500','px30w500'
                                ,'px14R', 'px18R', 'px20w400B', 'px28w600', 'px18w400LR','px50w800B', 'px50w600', 'px20w600_rec', 'px20w400_rec', 'px24w600_rec'
     ]),
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};

Text.defaultProps = {
    variant: 'body',
    className: '',
};

export default Text;